import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import { Link } from 'react-router-dom'
import Logo from '../CourseImages/Logo.png'
import './AdminNav.css'
import AttendClassModal from './AttendClassModal';
import { fetchImageData } from './fetchImage';
import dummy_user from "./dummy_user.png";

const AdminNav = ({ username, avatar, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const dropdownRef = useRef(null);
  const [imageData, setImageData] = useState(null);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setSelectedCourse(null);
  };

  // const handleCourseSelection = (Course_id) => {
  //   setIsOpen2(!isOpen2);
  //   setSelectedCourse(Course_id);
  // };
  const handleCourseSelection = (courseId) => {
    setSelectedCourse(courseId);
    setIsOpen2(prevState => prevState !== courseId);
    // onCourseSelect(courseId); // Not sure what this function does, but I assume it handles course selection.
  };

  useEffect(() => {
    fetchImageData(setImageData, avatar);

    axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getmyCourses`)
      .then(response => {
        console.log("response.data", response.data)
        setCourses(response.data);
      })
      .catch(error => {
        console.error('Error fetching courses:', error);
      });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setIsOpen2(false);
        setSelectedCourse(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const [courses, setCourses] = useState([]);

  return (
    <div style={{ width: "100%" }}>
      <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: "#edffff" }}>
        <div className="container-fluid">
          {/* Logo */}
          <img src={Logo} alt="Logo" className="pageLogo" />

          {/* Mobile Toggler */}
          <button style={{ marginLeft: "auto" }} className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navbar Items */}
          <div className="collapse navbar-collapse mx-3 Navbar-Right-Aligned" id="navbarSupportedContent">
            <ul className="navbar-nav" style={{ marginLeft: "10%" }}>

              <li className="nav-item">
                <Link className="navLinks" to="/">Home</Link>
              </li>

              {/* Users */}
              <li className="navLinks ">
                <a className="navLinks dropdown-toggle" href="#" id="usersDropdown" data-bs-toggle="dropdown">Users</a>
                <div className="dropdown-menu">
                  <Link className="dropdown-item UserDropdown" to="/ManageUser">Manage Users</Link>
                  <Link className="dropdown-item UserDropdown" to="/CourseRegistration">Course Registration</Link>
                  <Link className="dropdown-item UserDropdown" to="#">Potential Customers</Link>
                </div>
              </li>

              {/* Fees */}
              <li className="navLinks ">
                <a className="navLinks dropdown-toggle" href="#" id="feesDropdown" data-bs-toggle="dropdown">Fees</a>
                <div className="dropdown-menu">
                  <Link className="dropdown-item UserDropdown" to="/FeeConfig">Fee Config</Link>
                  <Link className="dropdown-item UserDropdown" to="/StudentFee">Student Fee</Link>
                </div>
              </li>

              {/* Courses */}
              <li className="navLinks" ref={dropdownRef}>
                <a className="nav-link dropdown-toggle navLinks" onClick={toggleDropdown}>
                  Courses
                </a>
                {isOpen && (
                  <li className="dropdown-menu-scrollable dropdown-menu_">
                    {courses.map((course) => (
                      <li key={course.Course_id}>
                        <a
                          className={`nav-link navLinks dropdown-item_ ${selectedCourse === course.Course_id ? 'active' : ''}`}
                          onClick={() => handleCourseSelection(course.Course_id)}
                          style={{ padding: "0" }}>
                          <span style={{ width: "30vh", padding: "1vh" }} className="dropdown-toggle course-text">{course.coursename}</span>
                        </a>
                        {isOpen2 && selectedCourse === course.Course_id && (
                          <li className="nested-dropdown-menu_">
                            <Link to="/admin_levels_coding" style={{ color: "#03b4c6", paddingLeft: "4vh" }} className=" dropdown-item_ ">Manage Content</Link> <br />
                            <Link to={`/admin_manage_classes/${course.Course_id}/${course.coursename}`} style={{ color: "#03b4c6", paddingLeft: "4vh" }} className="dropdown-item_ ">Manage Classes</Link><br />
                            <Link to="#" style={{ color: "#03b4c6", paddingLeft: "4vh" }} className="dropdown-item_ ">Student Progress</Link><br />
                            <a
                              style={{ color: "#03b4c6", paddingLeft: "4vh", cursor: "pointer" }}
                              className="dropdown-menu-scrollable dropdown-item_ "
                              onClick={handleOpenDialog}
                            >
                              Attend Class
                            </a> <br />
                            <Link to={`/gen_certificate/${course.Course_id}/${course.coursename}`} style={{ color: "#03b4c6", paddingLeft: "4vh" }} className="dropdown-item_ ">Generate Certificate</Link><br />
                            <Link to={`/gen_certificate2`} style={{ color: "#03b4c6", paddingLeft: "4vh" }} className="dropdown-item_ ">Generate Event Certificate</Link><br />

                          </li>
                        )}
                      </li>
                    ))}
                  </li>
                )}
                {isDialogOpen && (
                  <AttendClassModal isOpen={isDialogOpen} onClose={handleCloseDialog}
                    classes={courses} selectedCourse={selectedCourse} />
                )}
              </li>
              
              {/* Teachers */}
              <li className="navLinks ">
                <a className="navLinks dropdown-toggle" href="#" id="teachersDropdown" data-bs-toggle="dropdown">Teachers</a>
                <div className="dropdown-menu">
                  <Link className="dropdown-item UserDropdown" to="/TeacherProfile">Profile</Link>
                  <Link className="dropdown-item UserDropdown" to="/TeacherRating">Rating</Link>
                  <Link className="dropdown-item UserDropdown" to="/TeacherSalary">Salary</Link>
                </div>
              </li>

              {/* Gift Redeem */}
              <li className="navLinks ">
                <a className="navLinks dropdown-toggle" href="#" id="giftDropdown" data-bs-toggle="dropdown">Gift Redeem</a>
                <div className="dropdown-menu">
                  <Link className="dropdown-item UserDropdown" to="/ManageRewards">Manage Gifts</Link>
                  <Link className="dropdown-item UserDropdown" to="/RedeemRequest">Redeem Requests</Link>
                  <Link className="dropdown-item UserDropdown" to="/RedeemHistory">Redeem History</Link>
                </div>
              </li>
              <li className="navLinks ">
                <a className="navLinks dropdown-toggle" href="#" id="giftDropdown" data-bs-toggle="dropdown">Polymatch</a>
                <div className="dropdown-menu">
                  <Link className="dropdown-item UserDropdown" to="/PolymatchInvoice">Polymatch Invoice</Link>
                  <Link to={`/gen_certificate2`} className="dropdown-item UserDropdown">Generate Event Certificate</Link><br />
                </div>
              </li>

              {/* Communication */}
              <li className="nav-item">
                <Link className="navLinks" to="/MassCommunication">Communication</Link>
              </li>

              {/* ChatBot */}
              <li className="navLinks ">
                <a className="navLinks dropdown-toggle" href="#" id="chatbotDropdown" data-bs-toggle="dropdown">ChatBot</a>
                <div className="dropdown-menu">
                  <Link className="dropdown-item UserDropdown" to="/ChatbotAdminPanel">ChatBot</Link>
                  <Link className="dropdown-item UserDropdown" to="/chat-history">Chat History</Link>
                </div>
              </li>

              {/* Calendar */}
              <li className="nav-item">
                <Link className="navLinks" to="/calenderview">My Calender View</Link>
              </li>

              {/* Profile Avatar */}
              <li className="navLinks ">
                <a className="navLinks navLinksArrowHide dropdown-toggle" href="#" id="profileDropdown" data-bs-toggle="dropdown" style={{ padding: 0 }}>
                  {imageData ? (
                    <img src={imageData} alt="Avatar" className="avatar-image" />
                  ) : (
                    <img src={dummy_user} alt="Default Avatar" className="avatar-image" />
                  )}
                </a>
                <div className="dropdown-menu user-profile-dropdown">
                  <Link className="dropdown-item UserDropdown" onClick={onLogout}>Logout</Link>
                  <Link className="dropdown-item UserDropdown" to="/ChangePassword">Change Password</Link>
                  <Link className="dropdown-item UserDropdown" to="/AdminEdit">Edit Profile</Link>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </nav>

      {/* Attend Class Modal */}
      {isDialogOpen && (
        <AttendClassModal isOpen={isDialogOpen} onClose={handleCloseDialog} classes={courses} selectedCourse={selectedCourse} />
      )}
    </div>
  );
};

export default AdminNav;
